import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';   

@Injectable(
	{providedIn: 'root'}
)
export class DatabaseGwService {

	URL_PATH:string = "";

  	constructor(private $http: HttpClient,
		@Inject('env') private $env) { }

	/**
	 * Method request to API to create record depend on object extends it 
	 * @param records 		Object | Array of record that want to create  
	 * @returns Observable<any>
	 */
	create(records: any, customPath:string="", optionHeader:any = {}): Observable<any> {
		let data: any[] = Array.isArray(records) ? records : [records];
		// let objName: string = this.getObjectName(data);

		let objUrl = this.URL_PATH || '/error-object';

		//to allow user able to request custom path without object
		let requestUrl = this.isNotEmpty(customPath) ? customPath : objUrl;

		
		return this.$http.post(this.$env.API_EP + requestUrl, data, optionHeader);

	}

	/**
   * Method request to API to update record depend on object extends it 
   * @param records 		Object | Array of record that want to update  
   * @returns Observable<any>
   */
	update(records: any, customPath:string="", optionHeader:any={}): Observable<any> {
		let data: any[] = Array.isArray(records) ? records : [records];
		// let objName: string = this.getObjectName(data);

		let objUrl = this.URL_PATH || '/error-object';

		//to allow user able to request custom path without object
		let requestUrl = this.isNotEmpty(customPath) ? customPath : objUrl;

		return this.$http.put(this.$env.API_EP + requestUrl, data, optionHeader);
	}

	/**
   * Method request to API to delete record depend on object extends it 
   * @param records 		Object | Array of record that want to delete  
   * @returns Observable<any>
   */
	delete(records: any, customPath:string="", optionHeader:any={}): Observable<any> {
		let data: any[] = Array.isArray(records) ? records : [records];
		// let objName: string = this.getObjectName(data);
		let lstIds = data.map(obj => obj.id);
		let options: any = {};
		options.params = lstIds;

		let objUrl = this.URL_PATH || '/error-object';

		//to allow user able to request custom path without object
		let requestUrl = this.isNotEmpty(customPath) ? customPath : objUrl;

		return this.$http.delete(this.$env.API_EP + requestUrl, options);
	}

	/**
   * Method request to API to get record depend on object extends it 
   * @param filter 		filter object condition *required model_name 
   * @returns Observable<any>
   */
	query(filter:any={}, customPath:string="", optionHeader:any={}): Observable<any> {
		let opt = {};

		//get object name from filter to know which object should we use
		//and than delete the field because avoid confuse we filter with this field name
		// let objName: string = filter.model_name;
		// delete filter.model_name;

		if (filter && filter != {} && filter !== null && filter !== undefined) {
			let params: HttpParams = new HttpParams();
			for (const key in filter) {
				params = params.set(key, filter[key]);
			}
			opt["params"] = params;
		}

		if(optionHeader != {}){
			opt["headers"]= optionHeader;
		}


		let objUrl = this.URL_PATH || '/error-object';

		//to allow user able to request custom path without object
		let requestUrl = this.isNotEmpty(customPath) ? customPath : objUrl;
		return this.$http.get<any>(this.$env.API_EP + requestUrl, opt);
	}
 

	/**
   * Method request to API to create or update record depend on object extends it 
   * @param records 		Object | Array of record that want to create or update  
   * @returns Observable<any>
   */
	upsert(records: any, customPath:string="", optionHeader:any={}): Observable<any> {
		let data: any[] = Array.isArray(records) ? records : [records];
		// let objName: string = this.getObjectName(data);

		let objUrl = this.URL_PATH || '/error-object';

		//to allow user able to request custom path without object
		let requestUrl = this.isNotEmpty(customPath) ? customPath : objUrl;
		return this.$http.post(this.$env.API_EP + '/upsert-' + requestUrl.replace('/', ''), data, optionHeader);
	}

	private getObjectName(records) {
		return records[0].constructor.name;
	}

	private isNotEmpty(val:any):boolean{
		return val && val != null && val != undefined && val != "";
	}
}
